import { graphql } from "gql";

const INVITES_QUERY = graphql(`
  query Invites {
    invites {
      ...Invite
    }
  }
`);

export default INVITES_QUERY;
